// KWANKGM04070_本審査結果確認
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { StepNavigation as StepType } from '../../types/Template';
import { ShelfInfoObj, SetShelfInfo } from '../../types/FileUpload';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import FooterConfirmationOfMainExaminationResults from '../../organisms/FooterConfirmationOfMainExaminationResults';
import FileUpload from '../../templates/FileUpload';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_id: number;
  status_code: number;
  moveNextStep: () => void;
  guarantors_num: number;
  is_loading: boolean;
  display_status: boolean;
  show_error_nav: boolean;
  shelf_info: ShelfInfoObj;
  setShelfInfo: SetShelfInfo;
  reception_sub_cd: string;
  ident_lv1_cd: string;
  ident_lv2_cd: string;
  ident_lv3_cd: string;
  guarantor_info: GuarantorInfo;
  callApi: (function_name: string) => Promise<any>;
  is_secured: boolean;
  is_unsecured: boolean;
  is_agricultural_modernization_funds: boolean;
}

const ConfirmationOfMainExaminationResults: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  looks_inactive,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  reception_id,
  status_code,
  moveNextStep,
  guarantors_num,
  is_loading,
  display_status,
  show_error_nav,
  shelf_info,
  setShelfInfo,
  reception_sub_cd,
  ident_lv1_cd,
  ident_lv2_cd,
  ident_lv3_cd,
  guarantor_info,
  callApi,
  is_secured,
  is_unsecured,
  is_agricultural_modernization_funds,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <Reception
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
      />
      <FileUpload
        shelf_info={shelf_info}
        setShelfInfo={setShelfInfo}
        reception={{
          reception_id: reception_id,
          reception_cd: reception_cd,
          reception_sub_cd: reception_sub_cd,
          ident_lv1_cd: ident_lv1_cd,
          ident_lv2_cd: ident_lv2_cd,
          ident_lv3_cd: ident_lv3_cd,
          status_code: status_code,
        }}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        guarantor_info={guarantor_info}
        is_secured={is_secured}
        is_unsecured={is_unsecured}
        is_agricultural_modernization_funds={is_agricultural_modernization_funds}
      />
      <FooterConfirmationOfMainExaminationResults
        is_staff={false}
        reception_cd={reception_cd}
        reception_id={reception_id}
        status_code={status_code}
        moveNextStep={moveNextStep}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default ConfirmationOfMainExaminationResults;
